function appendQueryToShopifyImageUrl(url, query) {
  const urlParts = url.split("?");
  const baseUrl = urlParts[0];
  const queryString = urlParts[1] || "";

  const extensionMatch = baseUrl.match(/\.(jpg|jpeg|png|webp|gif|bmp|tiff)$/i);
  if (!extensionMatch) {
    return url;
  }

  const extensionIndex = extensionMatch.index;
  const modifiedBaseUrl = `${baseUrl.slice(
    0,
    extensionIndex
  )}_${query}${baseUrl.slice(extensionIndex)}`;

  return queryString ? `${modifiedBaseUrl}?${queryString}` : modifiedBaseUrl;
}

if (!customElements.get("product-form-update")) {
  class ProductFormUpdate extends HTMLElement {
    constructor() {
      super();

      this.initialized = false;
    }

    connectedCallback() {
      this.elSection = this.closest("section");
      this.elForm = this.querySelector("form");
      
      if (!this.elForm) {
        console.error('Form not found in product-form-update');
        return;
      }

      this.elVariant = this.elForm.querySelector('[name="id"]');
      this.elQuantity = this.elForm.querySelector('[name="quantity"]');
      this.elSellingPlanInput = this.elForm.querySelector('[name="selling_plan"]');
      this.elProperties = this.elForm.querySelectorAll(
        "input[name^='properties']"
      );
      this.elSubmit = this.elForm.querySelector('button[type="submit"]');
      this.elSubmitCopy = this.elSubmit?.querySelector("[data-copy]");
      
      const onetimeBlock = this.querySelector('.product-form--purchase.onetime');
      this.elPrice = onetimeBlock?.querySelector("[data-product-price]");
      this.elCap = onetimeBlock?.querySelector("[data-product-cap]");
      
      this.elPurchaseOptions = this.querySelectorAll('[name="subscription"]');
      this.elVariants = this.querySelector("[data-variants]");
      this.elStatus = this.elForm.querySelector("[data-status]");
      this.elMedia = this.elSection?.querySelector("[data-product-media]");
      this.elIngredients = this.elSection?.querySelector("[data-ingredients]");
      this.variantImagesData = document.getElementById("variant-images-data")
        ? JSON.parse(document.getElementById("variant-images-data").innerHTML)
        : {};

      if (this.elMedia && this.elMedia.swiper) {
        this.originalProductSlides = Array.from(
          this.elMedia.querySelectorAll(
            '.swiper-slide[data-default-media="true"]'
          )
        ).map((el) => {
          const node = el.cloneNode(true);
          node.classList.remove("none-important");
          return node;
        });
      }

      this.variants = JSON.parse(this.elVariants.innerHTML);
      
      this.currentVariant = this.variants.find(
        (v) => v.id == this.elVariant.value
      );
      this.currentOptions = { ...this.currentVariant.options };
      this.currentQuantity = Number(this.elQuantity.value);
      this.currentSubscription = null;
      this.hasSubscription = false;

      this.frequencyToPackSize = {
        '30 day supply': 'Single Pack',
        '60 day supply': 'Double Pack',
        '90 day supply': 'Triple Pack'
      };

      this.frequencyToPackSizeNoSymptoms = {
        '60 day supply': 'Single Pack'
      };

      this.packSizeOptionKey = this.findPackSizeOptionKey();
      
      this.symptomsToFrequency = this.buildSymptomsToFrequencyMap();

      this.elRecommendationBlock = this.querySelector('[data-recommendation-block]');
      this.elMultipleText = this.elRecommendationBlock?.querySelector('.multiple-text');
      this.elFewNoText = this.elRecommendationBlock?.querySelector('.few-no-text');

      this.showHideWaitlist();
      this.elForm.addEventListener("change", this.onFormChange.bind(this));
      this.elForm.addEventListener("submit", this.addToCart.bind(this));

      document.addEventListener(
        "countdown-finished",
        this.handleCountdownFinished.bind(this)
      );

      this.elPurchaseOptions.forEach(input => {
        input.addEventListener('change', () => {
          this.updateSelectedPurchaseBlocks();
        });
      });


      const userMadeSelection = this.hasUserMadeSelection();
      
      if (!userMadeSelection) {
        this.updateAvailableFrequencies(() => {
          this.preselectBestValueSubscription();
          this.updateSelectedPurchaseBlocks();
        });
      } else {
        this.updateAvailableFrequencies();
        this.updateAllSubscriptionPrices();
        this.updateSelectedPurchaseBlocks();
      }
      
      this.updatePrice();
      
      this.initialized = true;
      window.productFormUpdate = this;
    }

    checkIfVariantInUrl() {
      const url = new URL(window.location.href);
      return url.searchParams.has('variant');
    }

    hasUserMadeSelection() {
      const checkedSubscription = this.elForm.querySelector('input[name="subscription"]:checked');
      
      if (checkedSubscription && checkedSubscription.value !== 'onetime') {
        return true;
      }

      return this.checkIfVariantInUrl();
    }

    updateSelectedPurchaseBlocks() {
      const allPurchaseBlocks = this.querySelectorAll('.product-form--purchase');
      
      allPurchaseBlocks.forEach(block => {
        const input = block.querySelector('input[name="subscription"]');
        if (input && input.checked) {
          block.classList.add('selected');
        } else {
          block.classList.remove('selected');
        }
      });
    }

    findPackSizeOptionKey() {
      const packSizeValues = ['Single Pack', 'Double Pack', 'Triple Pack'];
      
      for (let key in this.currentOptions) {
        const value = this.currentOptions[key];
        if (packSizeValues.includes(value)) {
          return key;
        }
      }
      
      console.warn('Pack Size option not found in current options:', this.currentOptions);
      return null;
    }

    buildSymptomsToFrequencyMap() {
      const map = {};
      const symptomsFieldset = this.elForm.querySelector('.symptoms-option');
      
      if (!symptomsFieldset) {
        return {
          'Multiple Symptoms': ['30 day supply', '90 day supply'],
          'No Symptoms': ['60 day supply']
        };
      }

      const symptomInputs = symptomsFieldset.querySelectorAll('input[type="radio"]');
      
      symptomInputs.forEach(input => {
        const symptomValue = input.value;
        const frequencies = new Set();

        this.variants.forEach(variant => {
          const symptomsOptionKey = this.findSymptomsOptionKey();
          if (!symptomsOptionKey) return;

          if (variant.options[symptomsOptionKey] === symptomValue) {
            if (variant.selling_plans && variant.selling_plans.length > 0) {
              variant.selling_plans.forEach(plan => {
                const frequency = plan.name.toLowerCase();
                frequencies.add(frequency);
              });
            }
          }
        });

        if (frequencies.size > 0) {
          map[symptomValue] = Array.from(frequencies);
        }
      });

      return Object.keys(map).length > 0 ? map : {
        'Multiple Symptoms': ['30 day supply', '90 day supply'],
        'No Symptoms': ['60 day supply']
      };
    }

    findSymptomsOptionKey() {
      const symptomsFieldset = this.elForm.querySelector('.symptoms-option');
      if (!symptomsFieldset) return null;

      const symptomsInput = symptomsFieldset.querySelector('input[type="radio"]');
      if (!symptomsInput) return null;

      return symptomsInput.name;
    }

    handleCountdownFinished() {
      if (this.elForm.classList.contains("waitlist-active")) {
        this.elForm.classList.remove("waitlist-active");
        this.elSection && this.elSection.classList.remove("waitlist-active");

        const countdownContainer = document.querySelector(
          "[data-variant-waitlist]"
        );
        if (countdownContainer) {
          countdownContainer.style.display = "none";
        }
      }
    }

    onFormChange({ target }) {
      if (target.name === "subscription") {
        this.setCurrentSubscription(target.value);
      } else if (target.name.includes("option")) {
        this.setCurrentVariant(target.name, target.value);
      } else if (target.name === "quantity") {
        this.setCurrentQuantity(target.value);
      }
    }

    setCurrentSubscription(value) {
      this.hasSubscription = value !== "onetime";
      
      if (this.hasSubscription) {
        const sellingPlanId = value.replace("subscription-", "");
        
        this.currentSubscription = this.currentVariant.selling_plans.find(
          (plan) => plan.id == Number(sellingPlanId)
        );
        
        if (this.currentSubscription) {
          this.elSellingPlanInput.value = this.currentSubscription.id;
          
          const packSize = this.getPackSizeForFrequency(this.currentSubscription.name);
          if (packSize) {
            this.updatePackSizeInVariant(packSize);
          }
        }
      } else {
        this.currentSubscription = null;
        this.elSellingPlanInput.value = "";
        this.updatePackSizeInVariant('Single Pack');
      }
      
      this.updateSelectedPurchaseBlocks();
      this.updatePrice();
    }

    getPackSizeForFrequency(frequencyName) {
      const frequencyLower = frequencyName.toLowerCase();
      const currentSymptom = this.getCurrentSymptom();
      
      if (currentSymptom === 'No Symptoms') {
        return this.frequencyToPackSizeNoSymptoms[frequencyLower] || this.frequencyToPackSize[frequencyLower];
      }
      
      return this.frequencyToPackSize[frequencyLower];
    }

    updatePackSizeInVariant(packSize) {
      if (this.packSizeOptionKey) {
        this.currentOptions[this.packSizeOptionKey] = packSize;
        
        const newVariant = this.variants.find(
          (variant) =>
            JSON.stringify(variant.options) == JSON.stringify(this.currentOptions)
        );

        if (newVariant && newVariant.id !== this.currentVariant.id) {
          this.currentVariant = newVariant;
          this.elVariant.value = newVariant.id;
          
          if (!this.hasSubscription) {
            this.currentSubscription = null;
          } else if (this.currentSubscription) {
            const matchingPlan = this.currentVariant.selling_plans?.find(
              plan => plan.name === this.currentSubscription.name
            );
            if (matchingPlan) {
              this.currentSubscription = matchingPlan;
            }
          }

          this.elSubmit.disabled = !this.currentVariant.available;
          this.updatePrice();

          document.body.style.setProperty(
            "--color-background",
            this.currentVariant.color
          );
          this.updateMediaCarousel();
          this.updateVariantImages();
          this.updateIngredients();
          this.showHideWaitlist();
          
          this.updateAllSubscriptionPrices();

          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: {
              variant: this.currentVariant
            }
          }));

          window.history.replaceState({}, "", this.currentVariant.url);
        }
      }
    }

    getOptionNameByPosition(position) {
      const optionInput = this.elForm.querySelector(`[name="option${position}"]`);
      if (optionInput) {
        const fieldset = optionInput.closest('fieldset');
        const legend = fieldset?.querySelector('legend');
        return legend?.textContent.trim();
      }
      return null;
    }

    getCurrentSymptom() {
      const symptomsFieldset = this.elForm.querySelector('.symptoms-option');
      if (!symptomsFieldset) {
        console.warn('Symptoms fieldset not found');
        return null;
      }

      const symptomsInput = symptomsFieldset.querySelector('input[type="radio"]:checked');
      if (!symptomsInput) {
        return null;
      }

      return symptomsInput.value;
    }

    updateAvailableFrequencies(callback) {
      const currentSymptom = this.getCurrentSymptom();
      const availableFrequencies = this.symptomsToFrequency[currentSymptom] || [];

      this.updateRecommendationText(currentSymptom);

      const allPurchaseBlocks = this.querySelectorAll('.product-form--purchase');
      let currentSelectionStillAvailable = false;
      
      allPurchaseBlocks.forEach(block => {
        const frequency = block.getAttribute('data-frequency');
        
        if (block.classList.contains('onetime')) {
          block.style.display = '';
          block.style.order = '999';
          return;
        }

        if (frequency && availableFrequencies.length > 0) {
          const isAvailable = availableFrequencies.some(freq => 
            frequency.includes(freq)
          );
          block.style.display = isAvailable ? '' : 'none';
          
          const input = block.querySelector('input[name="subscription"]');
          if (input) {
            if (input.checked && isAvailable) {
              currentSelectionStillAvailable = true;
            }
            
            if (!isAvailable && input.checked) {
              input.checked = false;
            }
          }
        }
      });

      const visibleSubscriptions = Array.from(allPurchaseBlocks).filter(block => 
        block.classList.contains('subscription') && block.style.display !== 'none'
      );

      visibleSubscriptions.forEach((block, index) => {
        this.updateSubscriptionBadge(block);
      });

      this.updateAllSubscriptionPrices();

      this.updateAllSubscriptionBadges(() => {
        if (!currentSelectionStillAvailable) {
          this.preselectBestValueSubscription();
        }
        
        if (callback) {
          callback();
        }
      });
    }

    updateAllSubscriptionPrices() {
      const allPurchaseBlocks = this.querySelectorAll('.product-form--purchase.subscription');
      
      allPurchaseBlocks.forEach(block => {
        this.updateSubscriptionPrice(block);
      });
    }

    updateSubscriptionPrice(block) {
      const frequency = block.getAttribute('data-frequency');
      if (!frequency) return;

      const currentSymptom = this.getCurrentSymptom();
      let packSize;
      
      if (currentSymptom === 'No Symptoms') {
        packSize = this.frequencyToPackSizeNoSymptoms[frequency] || this.frequencyToPackSize[frequency];
      } else {
        packSize = this.frequencyToPackSize[frequency];
      }
      
      if (!packSize) return;

      const testOptions = { ...this.currentOptions };
      if (this.packSizeOptionKey) {
        testOptions[this.packSizeOptionKey] = packSize;
      }

      const variant = this.variants.find(v => 
        JSON.stringify(v.options) === JSON.stringify(testOptions)
      );

      if (!variant) return;

      const sellingPlanId = block.getAttribute('data-selling-plan-id');
      const allocation = variant.selling_plans?.find(plan => plan.id == Number(sellingPlanId));

      if (allocation) {
        const priceEl = block.querySelector('[data-subscription-price]');
        const capEl = block.querySelector('[data-subscription-cap]');

        if (priceEl) {
          priceEl.innerHTML = formatMoney(allocation.price, 0);
        }

        if (capEl) {
          if (allocation.cap && allocation.cap > allocation.price) {
            capEl.innerHTML = formatMoney(allocation.cap, 0);
            capEl.style.display = '';
          } else {
            capEl.style.display = 'none';
          }
        }
      }
    }

    updateAllSubscriptionBadges(callback) {
      const allPurchaseBlocks = this.querySelectorAll('.product-form--purchase.subscription');
      
      allPurchaseBlocks.forEach(block => {
        block.style.opacity = '0';
        block.style.transform = 'translateY(0.5rem)';
      });

      setTimeout(() => {
        let foundFirstBadge = false;

        allPurchaseBlocks.forEach((block, index) => {
          if (block.style.display === 'none') {
            this.removeSubscriptionBadge(block);
            return;
          }

          const shouldShowBadge = this.checkIfShouldShowBadge(block);
          
          if (shouldShowBadge && !foundFirstBadge) {
            this.updateSubscriptionBadge(block, shouldShowBadge);
            foundFirstBadge = true;
          } else {
            this.removeSubscriptionBadge(block);
          }
        });

        setTimeout(() => {
          allPurchaseBlocks.forEach(block => {
            block.style.opacity = '1';
            block.style.transform = 'translateY(0)';
          });
          
          if (callback) {
            callback();
          }
        }, 50);
      }, 150);
    }

    checkIfShouldShowBadge(block) {
      const frequency = block.getAttribute('data-frequency');
      if (!frequency) return null;

      const currentSymptom = this.getCurrentSymptom();
      let packSize;
      
      if (currentSymptom === 'No Symptoms') {
        packSize = this.frequencyToPackSizeNoSymptoms[frequency] || this.frequencyToPackSize[frequency];
      } else {
        packSize = this.frequencyToPackSize[frequency];
      }
      
      if (!packSize) return null;

      const testOptions = { ...this.currentOptions };
      if (this.packSizeOptionKey) {
        testOptions[this.packSizeOptionKey] = packSize;
      }

      const variant = this.variants.find(v => 
        JSON.stringify(v.options) === JSON.stringify(testOptions)
      );

      return variant && variant.tag ? variant.tag : null;
    }

    removeSubscriptionBadge(block) {
      const existingBadge = block.querySelector('.product-form--best-value-badge');
      if (existingBadge) {
        existingBadge.remove();
      }
      block.classList.remove('has-badge');
      block.style.order = '0';
      
      this.hideGiftBlock(block);
    }

    updateGiftBlock(block) {
      const frequency = block.getAttribute('data-frequency');
      if (!frequency) return;

      const currentSymptom = this.getCurrentSymptom();
      let packSize;
      
      if (currentSymptom === 'No Symptoms') {
        packSize = this.frequencyToPackSizeNoSymptoms[frequency] || this.frequencyToPackSize[frequency];
      } else {
        packSize = this.frequencyToPackSize[frequency];
      }
      
      if (!packSize) return;

      const testOptions = { ...this.currentOptions };
      if (this.packSizeOptionKey) {
        testOptions[this.packSizeOptionKey] = packSize;
      }

      const variant = this.variants.find(v => 
        JSON.stringify(v.options) === JSON.stringify(testOptions)
      );

      const giftBlock = block.querySelector('[data-gift-block]');
      if (!giftBlock) return;

      if (variant && variant.gift_image && variant.gift_title) {
        giftBlock.innerHTML = `
          <div class="subscription-gift-block-image">
            <img src="${variant.gift_image}" alt="Gift" width="44" height="44" class="cover">
          </div>
          <div class="subscription-gift-block-text">
            ${variant.gift_title}
          </div>
        `;
        giftBlock.style.display = 'flex';
      } else {
        this.hideGiftBlock(block);
      }
    }

    hideGiftBlock(block) {
      const giftBlock = block.querySelector('[data-gift-block]');
      if (giftBlock) {
        giftBlock.style.display = 'none';
        giftBlock.innerHTML = '';
      }
    }

    updateRecommendationText(symptom) {
      if (!this.elMultipleText || !this.elFewNoText) return;

      if (symptom === 'No Symptoms') {
        this.elMultipleText.style.display = 'none';
        this.elFewNoText.style.display = '';
      } else {
        this.elMultipleText.style.display = '';
        this.elFewNoText.style.display = 'none';
      }
    }

    updateSubscriptionBadge(block, badgeText) {
      let existingBadge = block.querySelector('.product-form--best-value-badge');
      
      if (!existingBadge) {
        existingBadge = document.createElement('div');
        existingBadge.className = 'product-form--best-value-badge';
        block.insertBefore(existingBadge, block.firstChild);
      }
      
      existingBadge.textContent = badgeText;
      block.classList.add('has-badge');
      block.style.order = '-1';
      
      this.updateGiftBlock(block);
    }

    findBestValueFrequency() {
      const currentSymptom = this.getCurrentSymptom();
      const availableFrequencies = this.symptomsToFrequency[currentSymptom] || [];

      for (const frequency of availableFrequencies) {
        let packSize;
        
        if (currentSymptom === 'No Symptoms') {
          packSize = this.frequencyToPackSizeNoSymptoms[frequency] || this.frequencyToPackSize[frequency];
        } else {
          packSize = this.frequencyToPackSize[frequency];
        }
        
        if (!packSize) continue;

        const testOptions = { ...this.currentOptions };
        if (this.packSizeOptionKey) {
          testOptions[this.packSizeOptionKey] = packSize;
        }

        const variant = this.variants.find(v => 
          JSON.stringify(v.options) === JSON.stringify(testOptions)
        );

        if (variant && variant.tag) {
          return frequency;
        }
      }

      return availableFrequencies[0];
    }

    getCurrentFlavor() {
      const flavorInputs = this.elForm.querySelectorAll('.product-form--option-value.flavor input[type="radio"]');
      for (const input of flavorInputs) {
        if (input.checked) {
          return input.value;
        }
      }
      return null;
    }

    preselectBestValueSubscription() {
      const allPurchaseBlocks = this.querySelectorAll('.product-form--purchase');
      let bestValueInput = null;
      let firstAvailableInput = null;

      for (const block of allPurchaseBlocks) {
        if (block.classList.contains('onetime')) continue;
        if (block.style.display === 'none') continue;
        
        const input = block.querySelector('input[name="subscription"]');
        if (!input || input.disabled) continue;

        if (!firstAvailableInput) {
          firstAvailableInput = input;
        }

        if (block.classList.contains('has-badge')) {
          bestValueInput = input;
          break;
        }
      }

      const inputToSelect = bestValueInput || firstAvailableInput;

      if (inputToSelect) {
        inputToSelect.checked = true;
        this.setCurrentSubscription(inputToSelect.value);
      } else {
        const onetimeInput = this.querySelector('#onetime');
        if (onetimeInput) {
          onetimeInput.checked = true;
        }
      }
    }

    setCurrentVariant(option, value) {
      this.currentOptions[option] = value;
      
      const optionInput = this.elForm.querySelector(`[name="${option}"]`);
      const fieldset = optionInput?.closest('fieldset');
      const isSymptomsOption = fieldset?.classList.contains('symptoms-option');
      
      if (isSymptomsOption) {
        this.updateAvailableFrequencies();
      }

      const packSize = this.hasSubscription && this.currentSubscription
        ? this.getPackSizeForFrequency(this.currentSubscription.name)
        : 'Single Pack';
      
      if (this.packSizeOptionKey && packSize) {
        this.currentOptions[this.packSizeOptionKey] = packSize;
      }

      this.currentVariant = this.variants.find(
        (variant) =>
          JSON.stringify(variant.options) == JSON.stringify(this.currentOptions)
      );

      if (!this.currentVariant) {
        const otherOptions = { ...this.currentOptions };
        if (packSizeOption) {
          delete otherOptions[packSizeOption];
        }
        
        this.currentVariant = this.variants.find((variant) => {
          const variantOtherOptions = { ...variant.options };
          if (packSizeOption) {
            delete variantOtherOptions[packSizeOption];
          }
          return JSON.stringify(variantOtherOptions) === JSON.stringify(otherOptions);
        });
      }

      if (this.currentVariant) {
        this.elVariant.value = this.currentVariant.id;

        if (this.hasSubscription && this.currentSubscription) {
          const matchingPlan = this.currentVariant.selling_plans?.find(
            plan => plan.name === this.currentSubscription.name
          );
          if (matchingPlan) {
            this.currentSubscription = matchingPlan;
          } else {
            this.currentSubscription = null;
            this.hasSubscription = false;
            const onetimeInput = this.querySelector('#onetime');
            if (onetimeInput) {
              onetimeInput.checked = true;
            }
          }
        }

        this.elSubmit.disabled = !this.currentVariant.available;
        this.updatePrice();

        document.body.style.setProperty(
          "--color-background",
          this.currentVariant.color
        );
        this.updateMediaCarousel();
        this.updateVariantImages();
        this.updateIngredients();
        this.showHideWaitlist();
        this.updateAllSubscriptionPrices();
        this.updateAllSubscriptionBadges();

        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: this.currentVariant
          }
        }));

        window.history.replaceState({}, "", this.currentVariant.url);
      }
    }

    updateVariantImages() {
      if (!this.elMedia || !this.elMedia.swiper) return;

      if (this.elMedia.closest('[data-product-media-black-friday]')) {
        return;
      }

      this.elMedia.classList.add("loading-variant");

      const variantId = this.currentVariant.id;
      const hasCustomImages =
        this.variantImagesData && this.variantImagesData[variantId];

      const variantSlides = this.elMedia.querySelectorAll(
        '.swiper-slide[data-variant-media="true"]'
      );

      const preloadImages = (images) => {
        return Promise.all(
          images.map((image) => {
            return new Promise((resolve) => {
              const img = new Image();
              img.onload = () => resolve(image);
              img.onerror = () => resolve(image);
              img.src = image.src;
            });
          })
        );
      };

      if (hasCustomImages) {
        this.elMedia
          .querySelectorAll('.swiper-slide[data-default-media="true"]')
          .forEach((slide) => {
            slide.classList.add("none-important");
          });

        const currentVariantSlides = Array.from(variantSlides).filter(
          (slide) => slide.getAttribute("data-variant-id") === String(variantId)
        );

        if (currentVariantSlides.length > 0) {
          variantSlides.forEach((slide) => {
            if (slide.getAttribute("data-variant-id") === String(variantId)) {
              slide.style.display = "";
              slide.classList.remove("loading");
            } else {
              slide.style.display = "none";
            }
          });

          const firstSlideIndex = Array.from(
            this.elMedia.swiper.slides
          ).indexOf(currentVariantSlides[0]);
          if (firstSlideIndex !== -1) {
            this.elMedia.swiper.slideTo(firstSlideIndex, 0);
          }

          setTimeout(() => {
            this.elMedia.classList.remove("loading-variant");
          }, 100);
        } else {
          variantSlides.forEach((slide) => {
            if (slide.getAttribute("data-variant-id") !== String(variantId)) {
              this.elMedia.swiper.removeSlide(
                Array.from(this.elMedia.swiper.slides).indexOf(slide)
              );
            }
          });

          const variantImages = this.variantImagesData[variantId];
          const slides = [];

          variantImages.forEach((image, index) => {
            const slide = document.createElement("div");
            slide.className = "product-media--slide swiper-slide loading";
            slide.setAttribute("data-index", index);
            slide.setAttribute("data-variant-media", "true");
            slide.setAttribute("data-variant-id", variantId);

            const figure = document.createElement("figure");

            const placeholder = document.createElement("div");
            placeholder.className = "product-media-placeholder";
            figure.appendChild(placeholder);

            slide.appendChild(figure);
            slides.push(slide);
          });

          slides.reverse().forEach((slide) => {
            this.elMedia.swiper.addSlide(0, slide);
          });

          this.elMedia.swiper.slideTo(0, 0);

          preloadImages(variantImages).then(() => {
            variantImages.forEach((image, index) => {
              const slideIndex = slides.length - 1 - index;
              const slide = slides[slideIndex];
              const figure = slide.querySelector("figure");
              const placeholder = figure.querySelector(
                ".product-media-placeholder"
              );

              if (placeholder) {
                const img = document.createElement("img");
                img.src = image.src;
                img.alt = image.alt || this.currentVariant.title;
                img.className = "cover";
                img.setAttribute("width", image.width);
                img.setAttribute("height", image.height);
                img.setAttribute("fetchpriority", "high");

                const widths = [375, 750, 928, 1108, 1500, 1856, 2216];
                const srcset = widths
                  .map((width) => {
                    const srcWithWidth = appendQueryToShopifyImageUrl(
                      image.src,
                      `${width}x`
                    );
                    return `${srcWithWidth} ${width}w`;
                  })
                  .join(", ");

                img.setAttribute("srcset", srcset);
                img.setAttribute(
                  "sizes",
                  "(min-width: 1680px) 1108px, (min-width: 1024px) 66vw, 100vw"
                );

                figure.replaceChild(img, placeholder);
                slide.classList.remove("loading");
              }
            });

            setTimeout(() => {
              this.elMedia.classList.remove("loading-variant");
            }, 200);
          });
        }

        const totalSlides = this.elMedia.swiper.slides.filter(
          (slide) =>
            slide.style.display !== "none" &&
            !slide.classList.contains("none-important")
        ).length;

        const elTooltip = this.elMedia.querySelector("tooltip-component");
        if (elTooltip) {
          const totalText = totalSlides < 10 ? `0${totalSlides}` : totalSlides;
          elTooltip.innerHTML = `<span data-product-media-current>01</span>/${totalText}`;
        }
      } else {
        variantSlides.forEach((slide) => {
          const slideIndex = Array.from(this.elMedia.swiper.slides).indexOf(
            slide
          );
          if (slideIndex !== -1) {
            this.elMedia.swiper.removeSlide(slideIndex);
          }
        });

        const currentProductSlides = this.elMedia.querySelectorAll(
          '.swiper-slide[data-default-media="true"]'
        );

        if (
          currentProductSlides.length === 0 ||
          Array.from(currentProductSlides).every((slide) =>
            slide.classList.contains("none-important")
          )
        ) {
          currentProductSlides.forEach((slide) => {
            const slideIndex = Array.from(this.elMedia.swiper.slides).indexOf(
              slide
            );
            if (slideIndex !== -1) {
              this.elMedia.swiper.removeSlide(slideIndex);
            }
          });

          if (
            this.originalProductSlides &&
            this.originalProductSlides.length > 0
          ) {
            this.originalProductSlides.forEach((originalSlide, index) => {
              const newSlide = originalSlide.cloneNode(true);
              newSlide.classList.add("loading");

              const figure = newSlide.querySelector("figure");
              if (figure) {
                const img = figure.querySelector("img");
                if (img) {
                  const placeholder = document.createElement("div");
                  placeholder.className = "product-media-placeholder";
                  placeholder.setAttribute("data-original-img", "");
                  figure.insertBefore(placeholder, img);
                  img.style.opacity = "0";

                  const loadImg = () => {
                    setTimeout(() => {
                      if (img.complete) {
                        placeholder.remove();
                        img.style.opacity = "1";
                        newSlide.classList.remove("loading");
                      } else {
                        img.onload = () => {
                          placeholder.remove();
                          img.style.opacity = "1";
                          newSlide.classList.remove("loading");
                        };
                      }
                    }, 100);
                  };

                  loadImg();
                }
              }

              this.elMedia.swiper.appendSlide(newSlide);
            });
          }
        } else {
          currentProductSlides.forEach((slide) => {
            slide.classList.remove("none-important");
          });
        }

        const totalSlides = this.elMedia.querySelectorAll(
          '.swiper-slide[data-default-media="true"]'
        ).length;

        const elTooltip = this.elMedia.querySelector("tooltip-component");
        if (elTooltip) {
          const totalText = totalSlides < 10 ? `0${totalSlides}` : totalSlides;
          elTooltip.innerHTML = `<span data-product-media-current>01</span>/${totalText}`;
        }

        this.updateMediaCarousel();
      }

      setTimeout(() => {
        this.elMedia.classList.remove("loading-variant");
      }, 300);
    }

    setCurrentQuantity(quantity) {
      this.currentQuantity = Number(quantity);
      this.updatePrice();
    }

    updatePrice() {
      this.updateOnetimePrice();

      const price =
        this.currentSubscription && this.hasSubscription
          ? this.currentSubscription.price
          : this.getSinglePackVariant()?.price || this.currentVariant.price * this.currentQuantity;
      const finalPrice = formatMoney(price, 0);

      this.elSubmitCopy.innerHTML = this.currentVariant.available
        ? `Add to Cart – ${finalPrice}`
        : "Sold Out";
    }

    updateOnetimePrice() {
      const singlePackVariant = this.getSinglePackVariant();
      
      if (!singlePackVariant) return;

      if (this.elPrice) {
        this.elPrice.innerHTML = formatMoney(
          singlePackVariant.price * this.currentQuantity,
          0
        );
      }
      
      if (this.elCap) {
        if (singlePackVariant.cap) {
          this.elCap.innerHTML = formatMoney(
            singlePackVariant.cap * this.currentQuantity,
            0
          );
          this.elCap.style.display = '';
        } else {
          this.elCap.style.display = 'none';
        }
      }
    }

    getSinglePackVariant() {
      if (!this.packSizeOptionKey) return this.currentVariant;

      const singlePackOptions = { ...this.currentOptions };
      singlePackOptions[this.packSizeOptionKey] = 'Single Pack';

      return this.variants.find(v => 
        JSON.stringify(v.options) === JSON.stringify(singlePackOptions)
      ) || this.currentVariant;
    }

    updateMediaCarousel() {
      if (!this.elMedia || !this.elMedia.swiper) return;

      const elSlide = [...this.elMedia.querySelectorAll(".swiper-slide")].find(
        (el) => {
          const variants = el.dataset.variants
            ? JSON.parse(el.dataset.variants).map((id) => Number(id))
            : null;
          return variants && variants.includes(this.currentVariant.id);
        }
      );

      if (elSlide) {
        const index = Number(elSlide.getAttribute("data-index"));
        this.elMedia.swiper.slideTo(index, 0);
      }
    }

    updateIngredients() {
      if (this.elIngredients && this.currentVariant.ingredients) {
        this.elIngredients.innerHTML = this.currentVariant.ingredients;
      }
    }

    showHideWaitlist() {
      const elWaitlist = this.querySelector("[data-variant-waitlist]");
      
      if (this.currentVariant.waitlist) {
        this.elForm.classList.add("waitlist-active");
        this.elSection && this.elSection.classList.add("waitlist-active");

        if (elWaitlist) {
          elWaitlist.innerHTML = this.currentVariant.waitlist;
        } else {
          const newWaitlist = document.createElement("div");
          newWaitlist.setAttribute("data-variant-waitlist", "");
          newWaitlist.innerHTML = this.currentVariant.waitlist;
          this.appendChild(newWaitlist);
        }
      } else {
        this.elForm.classList.remove("waitlist-active");
        this.elSection && this.elSection.classList.remove("waitlist-active");
        elWaitlist && elWaitlist.remove();
      }
    }

    addToCart(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      
      if (!this.initialized) {
        console.error('Form not initialized yet!');
        return false;
      }
      
      if (typeof window.addToCart !== 'function') {
        console.error('window.addToCart is not available');
        return false;
      }

      const { id } = this.currentVariant;

      const properties = this.elProperties
        ? Object.assign(
            {},
            ...[...this.elProperties].map((el) => {
              const name = el.name.split("properties[")[1].split("]")[0];
              return { [name]: el.value };
            })
          )
        : {};

      const data = {
        id,
        quantity: this.currentQuantity,
        properties: {
          ...properties,
        },
        ...(this.hasSubscription && this.currentSubscription
          ? { selling_plan: this.currentSubscription.id }
          : ""),
      };

      this.classList.add("adding");
      this.elStatus.innerHTML = `<span>Adding <span class="visually-hidden">${this.currentVariant.title} to cart</span>...</span>`;
      this.elSubmit.disabled = true;

      window.addToCart(data).then((response) => {
        this.classList.remove("adding");
        if (response.status) {
          this.classList.add("error");
          this.elStatus.innerHTML = `<span>Error<span class="visually-hidden"> adding ${this.currentVariant.title} to cart</span></span>`;
        } else {
          this.classList.add("success");
          this.elStatus.innerHTML = `<span>Added<span class="visually-hidden">${this.currentVariant.title}</span> to cart</span>`;
        }
        setTimeout(() => this.resetState(), 5000);
      }).catch((error) => {
        console.error('Error adding to cart:', error);
        this.classList.remove("adding");
        this.classList.add("error");
        this.elStatus.innerHTML = `<span>Error adding to cart</span>`;
        setTimeout(() => this.resetState(), 5000);
      });
      
      return false;
    }

    resetState() {
      this.classList.remove("error");
      this.classList.remove("success");
      this.elSubmit.disabled = false;
      setTimeout(() => {
        this.elStatus.innerHTML = "";
      }, 300);
    }
  }

  customElements.define("product-form-update", ProductFormUpdate);
}

